import { App_Url_New } from "@/src_new/shared/common/static";
import { whiteLabelResources } from "./resources";
import { WhiteLabelContactButton } from "./types";

const contactButtons: WhiteLabelContactButton[] = [
  {
    title: "Ava bot",
    subtitle: "Message us",
  },
  {
    title: "WhatsApp",
    subtitle: "Chat with us",
    href: "https://wa.me/6005089000",
  },
];

export const whiteLabelContent = {
  app: {
    title: "NexInsure",
    faviconPath: whiteLabelResources.App_Url.public.Favicon,
  },
  brand: {
    logo: {
      src: whiteLabelResources.App_Url.public.BrandLogo,
      alt: "NexInsure logo",
      width: 400,
      height: 100,
    },
    height: "",
    fallbackText: "",
  },
  company: {
    poweredBy: "NexAccel",
    legalEntity: "InsureHub Insurance",
  },

  contact: {
    phoneLabel: "600589000",
    phoneValue: "600589000",
    whatsappNumber: "600589000",
    generalEmail: "info@nexaccel.com",
    customerServiceEmail: "hello@nexaccel.com",
    chatbotAlertMessage: "Chatbot feature coming soon!",
  },
  homepage: {
    hero: {
      eyebrow: "Getting insurance can be confusing. InsureHub makes it simple.",
      titleLines: ["Click. Pick.", "Insure."],
      ctaLabel: "GET QUOTE",
      featuredProductPath: App_Url_New.secured.frontlinks.opportunitiesAdd,
    },
    stats: {
      dealsTitle: "Exciting deals",
      dealsSubtitle: "Limited period only",
      policyholdersCount: "25K",
      policyholdersLabel: "Happy policyholders",
    },
    whyChooseUs: {
      heading: "Why go with InsureHub?",
      imageAlt: "Why InsureHub",
      features: [
        {
          title: "Instant Coverage",
          description: "Get covered, anytime, anywhere with our simple digital platform.",
        },
        {
          title: "Top insurers",
          description: "We help you get the right product from trusted providers.",
        },
        {
          title: "Backed by the best",
          description: "We’re backed by Nexsys, a leading bank in the UAE for over 4 decades.",
        },
        {
          title: "Expert assistance",
          description: "Claim the stress-free way with friendly specialists by your side.",
        },
      ],
    },
    offers: {
      heading: "Tap into limited time offers",
      items: [
        {
          title: "Save AED 750*",
          description: "Get a AED 750 refund on your first claim on policies issued by NEXACCEL.",
          terms: "* Comprehensive policies only for individuals",
        },
        {
          title: "Enjoy ZERO interest",
          description:
            "Easy Payment Plan on Nexsys Credit Card - 3, 6, 9 and 12 months tenor available.",
          terms: "Terms and conditions",
        },
        {
          title: "Free car wash",
          description:
            "And discount on car services with AG Cars offered by Sukoon Insurance Company.",
          terms: "Terms and conditions",
        },
      ],
    },
    products: {
      eyebrowPrefix: "Click. Pick.",
      eyebrowHighlight: "Insure.",
      heading: "Top protection in your hands",
      ctaLabel: "GET QUOTE",
    },

    mascot: {
      heading: "Meet Ava",
      description: "Your go-to buddy for quick and fuss-free insurance solutions",
      imageAlt: "Insura Ava",
      pillars: [
        {
          title: "Buy",
          description: "Digitally or guided by friendly experts.",
        },
        {
          title: "Claim",
          description: "We'll help, so you can have peace-of-mind.",
        },
        {
          title: "Keep track",
          description: "With all your policy documents, secure and in one place.",
        },
      ],
    },
    contactSection: {
      heading: "Got question?",
      buttons: contactButtons,
    },
  },
  auth: {
    heroTitle: "Manage Complex Placements. Place Reinsurance Smarter.",

    heroDescription:
      "A unified platform for managing reinsurance placements across Treaty and Facultative business—from submission and negotiation to multi-reinsurer quoting, placement, and binding.",

    features: [
      {
        title: "End-to-End Placement",
        description:
          "Manage the complete placement lifecycle from submission and terms through negotiation, placement, and binding.",
        dotClassName: "bg-theme-success-strong",
      },
      {
        title: "Multi-Reinsurer Quoting",
        description:
          "Coordinate quotes and terms across multiple reinsurers through a structured placement workflow.",
        dotClassName: "bg-theme-success-strong",
      },
    ],
    copyrightText: "© 2026 NexAccel InsureHub Insurance Portal. All rights reserved.",
    brandSubtitle: "NexAccel",
    welcomeTitle: "Welcome Back",
    welcomeDescription: "Enter your credentials to access your dashboard",
    submitLabel: "Sign in",
    rememberLabel: "Remember me for 30 days",
    helpText: "Need access?",
    helpCtaLabel: "Contact your administrator",
    legalPrefix: "By signing in, you agree to our",
    legalLinks: [
      { label: "Terms of Service", href: "#" },
      { label: "Privacy Policy", href: "#" },
    ],
    otpFooterPrefix: "New to InsureHub?",
    otpFooterCta: "Get a quote",
    otpFooterSuffix: "to get started.",
  },
  journeys: {
    marketingConsentLabel:
      "I agree to receive updates from InsureHub about quotes, products and promotional offers through marketing channels including SMS and Email.",
    quoteMascotAlt: "Meet Ava",
    policyPending: {
      paymentPlanHeading: "EASY PAYMENT PLAN ON Nexsys",
      paymentPlanSubtext: "Credit Card (3, 6, 9 & 12 months)",
      specialistFollowUp: "One of our InsureHub specialists will contact you shortly.",
    },
    travel: {
      howItWorksHeading: "It’s easy to InsureHub",
      whyBetterHeading: "See what makes InsureHub better",
      paymentPlanText: "on Nexsys Credit Card",
      trustedByManyText: "Thousands insured with InsureHub",
    },
  },
  footer: {
    copyrightOwner: "NexAccel InsureHub",
    copyrightLink: "https://nexaccel.com/",
    regulatoryText:
      "NexAccel InsureHub empowers insurance brokers, aggregators, and banks to launch their own digital insurance marketplace in weeks. Compare quotes from multiple insurers, customize coverages, and bind policies seamlessly from a single platform.",
  },
} as const;
